import { IFilterConfigurationResponse } from '@patient-fi/fed-types';
import { useQuery, UseQueryOptions, UseQueryResult } from '@tanstack/react-query';

import HttpError from '../../utilities/HttpError';
import { IQueryKey } from '../../utilities/queryFnFactory';

const useFiltersConfiguration = (
  options?: Omit<
    UseQueryOptions<IFilterConfigurationResponse, HttpError, IFilterConfigurationResponse, IQueryKey>,
    'queryKey' | 'queryFn' | 'initialData'
  >,
): UseQueryResult<IFilterConfigurationResponse, HttpError> =>
  useQuery<IFilterConfigurationResponse, HttpError, IFilterConfigurationResponse, IQueryKey>([`/filters/configuration`], options);

export default useFiltersConfiguration;
